exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\n  Main Component SCSS\n */\n:host {\n  display: block;\n  height: 100%; }\n\np {\n  color: #555555; }\n\nh2 {\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.scss
// module id = 387
// module chunks = 1